import TruncatingText from '@app/src/components/Ui/TruncatingText'
import useLocalisedCountryName from '@app/src/hooks/useLocalisedCountryName'
import { Stack } from '@mui/material'
import type { TypographyProps } from '@mui/material/Typography'
import Typography from '@mui/material/Typography'
import React from 'react'
import ReactCountryFlag from 'react-country-flag'
import ParentCellOrFragment from './ParentCellOrFragment'

type CountryCellProps = {
  countryCode?: string
  disableCell?: boolean
} & TypographyProps

const CountryCell: React.FC<CountryCellProps> = ({ countryCode, disableCell, ...props }) => {
  const { getLocalisedCountryName } = useLocalisedCountryName()
  const localisedCountryName = getLocalisedCountryName(countryCode)

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      {localisedCountryName ? (
        <Stack direction="row" alignItems="center" spacing={1} minWidth={0}>
          {countryCode && (
            <ReactCountryFlag
              countryCode={countryCode}
              svg
              style={{ fontSize: '1.5em', flexShrink: 0 }}
              title={localisedCountryName}
            />
          )}
          <TruncatingText text={localisedCountryName} {...props} />
        </Stack>
      ) : (
        <Typography {...props}>-</Typography>
      )}
    </ParentCellOrFragment>
  )
}

export default CountryCell
